// Module
var code = "<h2 class=\"interiorSectionHeading align-center\"> Diversify your loan offerings; help more students. </h2> ";
// Exports
export default code;